import { gql } from '@apollo/client';

export const FETCH_USER_USAGE = gql`
  query FetchUserUsage {
    userProfile {
      id
      size
      pageQuota
      usedPages
    }
  }
`; 